import type { StudyDay } from "@/hooks/useStudentDashboard";

interface WeeklyChartProps {
  studyDays: StudyDay[];
  loading: boolean;
}

function dayLabel(iso: string): string {
  const d = new Date(`${iso}T00:00:00`);
  return d.toLocaleDateString("tr-TR", { weekday: "short" });
}

export default function WeeklyChart({ studyDays, loading }: WeeklyChartProps) {
  const max = Math.max(...studyDays.map((d) => d.minutes), 1);

  if (loading) {
    return (
      <div className="rounded-lg border border-background-200 bg-background-50 p-5 h-full">
        <h3 className="font-heading font-semibold text-base text-foreground-950">Haftalık Çalışma</h3>
        <div className="mt-6 flex items-end gap-3 h-32">
          {Array.from({ length: 7 }).map((_, i) => (
            <div key={i} className="flex-1 rounded-md bg-background-100 animate-pulse" style={{ height: `${30 + (i * 8) % 60}%` }} />
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-5 h-full flex flex-col">
      <div className="flex items-center justify-between">
        <h3 className="font-heading font-semibold text-base text-foreground-950">Haftalık Çalışma</h3>
        <span className="text-xs text-foreground-500">dakika</span>
      </div>

      <div className="mt-6 flex items-end gap-2 md:gap-3 flex-1 min-h-32">
        {studyDays.map((d) => (
          <div key={d.date} className="flex-1 flex flex-col items-center gap-2">
            <span className="text-[10px] text-foreground-500">
              {d.minutes > 0 ? d.minutes : ""}
            </span>
            <div
              className={`w-full rounded-md transition-all ${
                d.minutes > 0 ? "bg-primary-500" : "bg-background-100"
              }`}
              style={{ height: `${Math.max((d.minutes / max) * 100, d.minutes > 0 ? 8 : 4)}%` }}
            />
            <span className="text-[10px] text-foreground-500 whitespace-nowrap">{dayLabel(d.date)}</span>
          </div>
        ))}
      </div>
    </div>
  );
}